module.exports = __webpack_public_path__ + "static/media/id2.4eb4915c.jpg";